<template>
	<div class="content">
		<!-- <h5 class="mb-2">{{details.title}}</h5> -->
		<div v-if="loading" class="loading">加载中...</div>
		<div v-else-if="error" class="error">{{ error }}</div>
		<div v-else>
			<div v-html="details.content"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "doc",
		data() {
			return {
				id: 2,
				details: {},
				loading: false,
				error: null
			};
		},
		watch: {
			$route(to, from) {
				this.id = this.$route.query.id;
				this.fetchItems();
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.fetchItems();
		},
		methods: {
			fetchItems() {
				let _this = this;
				let id = this.id;
				_this.loading = true;
				_this.error = null;
				
				_this.$axios.get('/index/index/article/', {
					params: {
						id: id
					}
				}).then(function(response) {
					if (response.data.data) {
						_this.details = response.data.data;
					} else {
						_this.error = '未找到文章数据';
					}
				}).catch(function(error) {
					_this.error = '加载文章失败，请稍后重试';
					console.error('Article fetch error:', error);
				}).finally(function() {
					_this.loading = false;
				});
			}
		}
	};
</script>

<style>
	.content {
		padding: 20px;
	}
	.loading, .error {
		text-align: center;
		padding: 20px;
	}
	.error {
		color: #f56c6c;
	}
</style>